"use client";

import { useChatActions } from "@ai-sdk-tools/store";
import { AnimatePresence, motion } from "motion/react";
import { Button } from "@/components/ui/button";

const PROMPTS = [
  "Explain the 3 important parts of the brain",
  "Get a classroom activity",
  "Recommend a mindful breathing exercise",
];

interface SuggestedPromptsProps {
  delay?: number;
}

export function SuggestedPrompts({ delay = 0 }: SuggestedPromptsProps = {}) {
  const { sendMessage } = useChatActions();

  const handlePromptClick = (prompt: string) => {
    sendMessage({ text: prompt });
  };

  return (
    <AnimatePresence mode="wait">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 10 }}
        transition={{ duration: 0.3, delay, ease: "easeOut" }}
        className="flex gap-2 mb-2 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
      >
        {PROMPTS.map((prompt, index) => (
          <motion.div
            key={prompt}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{
              duration: 0.2,
              delay: delay + index * 0.05,
              ease: "easeOut",
            }}
          >
            <Button
              size="sm"
              onClick={() => handlePromptClick(prompt)}
              className="rounded-full text-xs bg-[#f8f3ef] font-normal text-[#5c544d] hover:text-[#1f1b17] hover:bg-[#d7f5ec] border border-[#eaded2] backdrop-blur-sm flex-shrink-0 whitespace-nowrap"
            >
              {prompt}
            </Button>
          </motion.div>
        ))}
      </motion.div>
    </AnimatePresence>
  );
}
